import React from 'react';

export const PackagesMiniContext = React.createContext();
